export default __webpack_public_path__ + "static/118-048671b5728069ae676a523e1e513cf6.png";